import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await register(email, password, name);
      toast.success(`Welcome to Maison Luxe, ${u.name || u.email}`);
      navigate("/account");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-6 py-20">
      <p className="small-label">Become a member</p>
      <h1 className="font-serif text-4xl mt-3">Create your account</h1>
      <p className="text-stone text-sm mt-2">Track orders, save addresses, get early access to drops.</p>
      <form onSubmit={submit} className="mt-8 space-y-3">
        <input required placeholder="Full name" value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name" className="w-full bg-ivory border border-stone-line rounded-2xl px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-charcoal" />
        <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email" className="w-full bg-ivory border border-stone-line rounded-2xl px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-charcoal" />
        <input required type="password" placeholder="Password (min 6 chars)" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password" className="w-full bg-ivory border border-stone-line rounded-2xl px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-charcoal" />
        <button disabled={busy} data-testid="register-submit" className="btn-primary w-full">{busy ? "Creating…" : "Create account"}</button>
      </form>
      <p className="text-sm text-stone mt-6 text-center">Already have an account? <Link to="/login" className="underline text-charcoal">Login</Link></p>
    </div>
  );
}
